import * as angular from "angular";
import * as _ from "lodash";
import {SplitService} from "../../commons/services/split-service.service";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";
import {ApiConfig} from "../../commons/models/api-config.model";

export class CoordinationRequests {

  /* @ngInject */
  constructor(private coordinationsAPI: BringozApi, private $coordinations, private apiConfig: ApiConfig,
              private splitService: SplitService, private Upload) {
  }

  // ******************************
  // External methods
  // ******************************

  editCoordination(coordinationId, timestamp) {
    const api = this.coordinationsAPI.actions.createCoordination;
    return this.$$call(api, {date: timestamp}, {}, {}, coordinationId);
  }

  uploadCoordinationExcel(file) {
    const siteId = this.getSiteId();
    return this.Upload.upload({
      url: this.apiConfig.baseUrl + `/coordinations/upload?siteId=` + siteId,
      method: 'POST',
      data: {
        file: file
      }
    });
  }

  getServices(coordinationId, status) {
    const api = this.coordinationsAPI.actions.getServices;

    if (_.isUndefined(status)) {
      status = '';
    }

    return this.$$call(api, {orderId: coordinationId, coordinationStatusGroup: status}, {}, {});
  }

  editService(serviceId, payload) {
    const api = this.coordinationsAPI.actions.updateService;
    return this.$$call(api, {}, payload, {id: serviceId});
  }

  sendAllServicesSMS(coordinationId) {
    const api = this.coordinationsAPI.actions.sendAllServicesSMS;
    return this.$$call(api, {}, {}, {id: coordinationId});
  }

  declineCoordination(coordinationId) {
    const api = this.coordinationsAPI.actions.declineCoordination;
    return this.$$call(api, {}, {}, {id: coordinationId});
  }

  createAllDeliveries(coordinationId, payload) {
    const api = this.coordinationsAPI.actions.createAllDeliveries;
    return this.$$call(api, {}, payload, {id: coordinationId});
  }

  createDeliveries(serviceIds, payload) {
    const api = this.coordinationsAPI.actions.createDeliveries;
    return this.$$call(api, {ids: serviceIds}, payload, {});
  }

  createDelivery(serviceId) {
    const api = this.coordinationsAPI.actions.createDelivery;
    return this.$$call(api, {ids: [serviceId]}, {}, {});
  }

  sendServicesTextMessage(serviceIdOrIds) {
    if (!_.isArray(serviceIdOrIds)) {
      serviceIdOrIds = [serviceIdOrIds]
    }
    const api = this.coordinationsAPI.actions.sendServiceSMS;
    return this.$$call(api, {ids: serviceIdOrIds}, {}, {});
  }

  declineServices(serviceIdOrIds) {
    if (!_.isArray(serviceIdOrIds)) {
      serviceIdOrIds = [serviceIdOrIds]
    }
    const api = this.coordinationsAPI.actions.declineService;
    return this.$$call(api, {ids: serviceIdOrIds}, {}, {});
  }

  // ******************************
  // Internal methods
  // ******************************

  private $$call(_apiCall, _queryParams, _data, _pathParams, _coordinationId?) {
    return this.$coordinations(_coordinationId).$call(_apiCall, _queryParams, _data, _pathParams);
  }


  getSiteId() {
    return this.splitService.getSiteId();
  }
}

angular
  .module('bringoz.admin.coordinations')
  .service('coordinationRequests', CoordinationRequests);
